import { Helmet } from 'react-helmet-async';
import BreadCrumbs from '../../components/BreadCrumbs/BreadCrumbs';
import { IoCheckmarkCircleOutline } from "react-icons/io5";

const LmpProgramsCoordinators = () => {

  return (
    <section className='w-full bg-cover h-fit pb-5'>

      <Helmet>
        <title>Program Coordinators</title>
        <meta name="description" content="Learn more about MIJSC, our mission, vision, and commitment to excellence." />
      </Helmet>
      <BreadCrumbs />
      <section className='w-full bg-cover h-fit pb-5'>


        <div className=' w-[94%] text-justify'>
          <section className='w-full h-fit md:mx-10 mx-5 mb-5 ' >
            <h1 className="md:text-4xl text-lg py-5 font-semibold uppercase text-left">LMP Program <br />
              <span className="text-green-600"> Coordinators</span>
            </h1>
          </section>
        </div>


        <section className=" py-0 px-5 md:px-5 lg:px-8 bg-white ">
          <div className="max-w-7xl mx-auto">

            <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-24 text-left mb-10 md:mt-0">
              <div className="md:col-span-5">
                  <figure className="w-full rounded-[30px] overflow-hidden ">
                    <img
                      src="/assets/prabha-narayana.png"
                      alt="Prabha Narayana"
                      className="w-full h-full object-contain"
                    />
                  </figure>
              </div>

              {/* Content */}
              <div className="md:col-span-7 content-center">
                <div className="flex gap-3 items-center mt-3">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-bold text-sm text-gray-600">
                    Research Associate, Mizuho India Japan Study Centre @ IIMB
                  </p>
                </div>
                <div className="flex gap-3 items-center">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-semibold text-sm my-2 text-gray-600">
                    Program Coordinator for the Lean Manufacturing Practices Program
                  </p>
                </div>
                <div className="flex gap-3 items-center">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-semibold text-sm my-2 text-gray-600">
                    9 years of teaching and research experience in the area of interest.
                  </p>
                </div>
              </div>

              {/* ====== PROFILE 2 ====== */}
              <div className="md:col-span-5 mt-10 md:mt-0">
               
                  <figure className="w-full rounded-[30px] overflow-hidden">
                    <img
                      src="/assets/akshay-rao.png"
                      alt="Akshay Rao"
                      className="w-full h-full object-contain"
                    />
                  </figure>
              </div>

              {/* Content */}
              <div className="md:col-span-7 content-center">
                <div className="flex gap-3 items-center mt-3">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-bold text-sm text-gray-600">
                    Research Associate, Mizuho India Japan Study Centre @ IIMB
                  </p>
                </div>
                <div className="flex gap-3 items-center">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-semibold text-sm my-2 text-gray-600">
                    Working on Verification of Business Evaluation and Transformation Index Framework.
                  </p>
                </div>
                <div className="flex gap-3 items-center">
                  <IoCheckmarkCircleOutline className="text-xl text-green-600 shrink-0" />
                  <p className="font-semibold text-sm my-2 text-gray-600">
                    Assigned with development of MOOC's Courses offered by MIJSC through IIMBx on Lean Manufacturing Practices.
                  </p>
                </div>
              </div>

            </div>
          </div>
        </section>



      </section>
    </section>
  )
}

export default LmpProgramsCoordinators
